export default "__VITE_ASSET__CuV5fyRi__"